import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Container} from 'views/components';

import {useLocation, ErrorBoundary} from 'views/module';
import {LinearProgress} from 'views/components';

import Navbar from 'views/module/appbar/navbar/Navbar';
import Status from 'views/module/status/Status';
import InternalServerError from './error/InternalServerError';

import LoggedInRoutes from './LoggedInRoutes';
import LoggedOutRoutes from './LoggedOutRoutes';

const Site = (props) => {
  const location = useLocation();
  const user = props.user;

  const showSite = Boolean(user?.lastLoadTime);
  const loggedIn = Boolean(user?.userRn);


  if (showSite && !loggedIn) {
    return (
      <ErrorBoundary FallbackComponent={InternalServerError}>
        <Container
          maxWidth={false}
          disableGutters sx={{'backgroundColor': 'background.main'}}
        >
          <LoggedOutRoutes />
        </Container>
      </ErrorBoundary>
    );
  } else if (showSite && loggedIn) {
    return (
      <ErrorBoundary FallbackComponent={InternalServerError}>
        <Container
          maxWidth={false}
          disableGutters sx={{'backgroundColor': 'background.main'}}
        >
          <Navbar />
          <Status showProgressBar={true} location={location}/>
          <Container
            fixed
            disableGutters
            maxWidth={'xxl'}
            sx={{
              minHeight: '99vh',
              px: {lg: '8px', xs: '8px'},
              py: {lg: '16px', xs: '8px'},
              pl: {navbarHide: `248px`, sx: '0px'},
            }}
          >
            <ErrorBoundary FallbackComponent={InternalServerError}>
              <LoggedInRoutes />
            </ErrorBoundary>
          </Container>
        </Container>
      </ErrorBoundary>
    );
  } else {
    return (
      <LinearProgress color="secondary" />
    );
  }
};

Site.propTypes = {
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, dispatch)(React.memo(Site));


